import React from "react";
import { Row, Col } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import img1 from "../assets/box/box1.png";
import img2 from "../assets/box/box2.png";
import img3 from "../assets/box/box3.png";
import img4 from "../assets/box/box4.png";


function Catagories() {
  return (
    <div className="main-catagiores relative  z-10">
      <div className="container">
        <Row gutter={16} align="middle">
          <Col xs={24} md={24}>
            <div className="catagoriestext1 text-center">
              <h5 className="text-sm font-medium text-[30px] text-black mb-2 font-custom capitalize">
                <span className="text-[#6cc5bf] text-4xl">_</span> All print
                categories
              </h5>
              <h1 className="text-4xl md:text-6xl font-bold text-black font-custom leading-snug md:leading-[1.3] capitalize">
                Explore all categories
              </h1>
            </div>
          </Col>
        </Row>

        {/* Swiper */}
        <Swiper
          direction={"vertical"}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          modules={[Pagination, Autoplay]}
          className="mySwiper w-full h-[700px] md:h-[700px]"
        >
          {/* Slide 1 */}
          <SwiperSlide >
            <Row gutter={16}>
              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5 mb-5 relative h-full">
                  <div className="box-custom1 gap-[30px] items-center flex">
                    <img src={img1} alt="T-shirts" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom T-Shirts
                      </h2>
                      <ul>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Shortsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Longsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Tank Tops
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Youth T-Shirts
                        </li>
                      </ul>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      80+ items
                    </a>
                  </span>
                </div>
              </Col>

              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5 mb-5 relative h-full">
                  <div className="box-custom2 gap-[30px] flex items-center">
                    <img src={img4} alt="Custom Boxes" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom Mugs
                      </h2>
                      <p className="font-outfit p-1 text-[17px] text-[#72747C] w-80">
                        Our online tools make the process as simple and clear as
                        possible.
                      </p>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      50+ items
                    </a>
                  </span>
                </div>
              </Col>
              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5  mb-5 relative h-full">
                  <div className="box-custom1 gap-[30px] items-center flex">
                    <img src={img2} alt="T-shirts" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom Hatss
                      </h2>
                      <ul>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Shortsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Longsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Tank Tops
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Youth T-Shirts
                        </li>
                      </ul>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      80+ items
                    </a>
                  </span>
                </div>
              </Col>

              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5 mb-5 relative h-full">
                  <div className="box-custom2 gap-[30px] flex items-center">
                    <img src={img3} alt="Custom Boxes" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom Boxes
                      </h2>
                      <p className="font-outfit p-1 text-[17px] text-[#72747C] w-80">
                        Our online tools make the process as simple and clear as
                        possible.
                      </p>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      50+ items
                    </a>
                  </span>
                </div>
              </Col>
            </Row>
          </SwiperSlide>

          {/* Slide 2 - duplicate for demo */}
          <SwiperSlide className="mt-5">
            <Row gutter={16}>
              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5 mb-5 relative h-full">
                  <div className="box-custom1 gap-[30px] items-center flex">
                    <img src={img1} alt="T-shirts" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom T-Shirts
                      </h2>
                      <ul>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Shortsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Longsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Tank Tops
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Youth T-Shirts
                        </li>
                      </ul>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      80+ items
                    </a>
                  </span>
                </div>
              </Col>

              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5 mb-5 relative h-full">
                  <div className="box-custom2 gap-[30px] flex items-center">
                    <img src={img4} alt="Custom Boxes" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom Mugs
                      </h2>
                      <p className="font-outfit p-1 text-[17px] text-[#72747C] w-80">
                        Our online tools make the process as simple and clear as
                        possible.
                      </p>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      50+ items
                    </a>
                  </span>
                </div>
              </Col>
              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5  mb-5 relative h-full">
                  <div className="box-custom1 gap-[30px] items-center flex">
                    <img src={img2} alt="T-shirts" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom Hatss
                      </h2>
                      <ul>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Shortsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Longsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Tank Tops
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Youth T-Shirts
                        </li>
                      </ul>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      80+ items
                    </a>
                  </span>
                </div>
              </Col>

              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5 mb-5 relative h-full">
                  <div className="box-custom2 gap-[30px] flex items-center">
                    <img src={img3} alt="Custom Boxes" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom Boxes
                      </h2>
                      <p className="font-outfit p-1 text-[17px] text-[#72747C] w-80">
                        Our online tools make the process as simple and clear as
                        possible.
                      </p>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      50+ items
                    </a>
                  </span>
                </div>
              </Col>
            </Row>
          </SwiperSlide>
          <SwiperSlide className="mt-5">
            <Row gutter={16}>
              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5 mb-5 relative h-full">
                  <div className="box-custom1 gap-[30px] items-center flex">
                    <img src={img1} alt="T-shirts" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom T-Shirts
                      </h2>
                      <ul>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Shortsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Longsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Tank Tops
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Youth T-Shirts
                        </li>
                      </ul>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      80+ items
                    </a>
                  </span>
                </div>
              </Col>

              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5 mb-5 relative h-full">
                  <div className="box-custom2 gap-[30px] flex items-center">
                    <img src={img4} alt="Custom Boxes" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom Mugs
                      </h2>
                      <p className="font-outfit p-1 text-[17px] text-[#72747C] w-80">
                        Our online tools make the process as simple and clear as
                        possible.
                      </p>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      50+ items
                    </a>
                  </span>
                </div>
              </Col>
              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5  mb-5 relative h-full">
                  <div className="box-custom1 gap-[30px] items-center flex">
                    <img src={img2} alt="T-shirts" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom Hatss
                      </h2>
                      <ul>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Shortsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Longsleeve Tees
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Tank Tops
                        </li>
                        <li className="font-outfit p-1 text-[17px] text-[#72747C]">
                          Youth T-Shirts
                        </li>
                      </ul>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      80+ items
                    </a>
                  </span>
                </div>
              </Col>

              <Col xs={24} md={12} className="mt-5">
                <div className="main-catagories-dev border p-5 mt-5 mb-5 relative h-full">
                  <div className="box-custom2 gap-[30px] flex items-center">
                    <img src={img3} alt="Custom Boxes" />
                    <div>
                      <h2 className="font-custom text-black text-[30px] mb-4">
                        Custom Boxes
                      </h2>
                      <p className="font-outfit p-1 text-[17px] text-[#72747C] w-80">
                        Our online tools make the process as simple and clear as
                        possible.
                      </p>
                    </div>
                  </div>
                  <span className="font-custom group absolute top-0 right-0 p-2 border mt-3 mr-3 bg-[#6cc5bf] hover:bg-[#fbf3f9]">
                    <a
                      className="text-white group-hover:text-[#72747C]"
                      href="/"
                    >
                      50+ items
                    </a>
                  </span>
                </div>
              </Col>
            </Row>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}

export default Catagories;
